import { inject, Injectable } from '@angular/core';
import { StateContext } from '@ngxs/store';
import { TableStateModel } from '../table.state.model';
import { Pagination } from '@core/models/pagination.model';
import { TableActions } from '../table.actions';
import { ProductsService } from '@core/services/products.service';

@Injectable({
  providedIn: 'root',
})
export class LCMProductHandler {
  constructor() {}
  productService = inject(ProductsService);

  handleFDProductLoad(ctx: StateContext<TableStateModel>, params: Pagination) {
    this.productService.getAllFixedDepositProducts({ ...params }).subscribe({
      next: (response) => {
        ctx.dispatch(
          new TableActions.LoadTableDataSuccess({
            tableKey: 'fixedDeposits',
            data: response.data?.data,
            totalCount: response.data?.total_count,
          })
        );
      },
      error: (error) => {
        ctx.dispatch(
          new TableActions.LoadTableDataFailure({
            tableKey: 'fixedDeposits',
            error: error.message,
          })
        );
      },
    });
  }

  handleTBillProductLoad(
    ctx: StateContext<TableStateModel>,
    params: Pagination
  ) {
    this.productService.getTreasuryBills({ ...params }).subscribe({
      next: (response) => {
        ctx.dispatch(
          new TableActions.LoadTableDataSuccess({
            tableKey: 'tbills',
            data: response.data?.data,
            totalCount: response.data?.total_count,
          })
        );
      },
      error: (error) => {
        ctx.dispatch(
          new TableActions.LoadTableDataFailure({
            tableKey: 'tbills',
            error: error.message,
          })
        );
      },
    });
  }

  searchTbillProduct(
    ctx: StateContext<TableStateModel>,
    action: TableActions.SearchTBillProduct
  ) {
    this.productService
      .searchTbillProducts(action.payload.searchText)
      .subscribe({
        next: (response) => {
          ctx.dispatch(
            new TableActions.LoadTableDataSuccess({
              tableKey: 'tbills',
              data: response?.data,
              totalCount: 10,
            })
          );
        },
        error: (error) => {
          ctx.dispatch(
            new TableActions.LoadTableDataFailure({
              tableKey: 'tbills',
              error: error.message,
            })
          );
        },
      });
  }

  handleBondsProductLoad(
    ctx: StateContext<TableStateModel>,
    params: Pagination
  ) {
    this.productService.getAllBondsProducts({ ...params }).subscribe({
      next: (response) => {
        ctx.dispatch(
          new TableActions.LoadTableDataSuccess({
            tableKey: 'bonds',
            data: response.data?.data,
            totalCount: response.data?.total_count,
          })
        );
      },
      error: (error) => {
        ctx.dispatch(
          new TableActions.LoadTableDataFailure({
            tableKey: 'bonds',
            error: error.message,
          })
        );
      },
    });
  }

  searchBondsProduct(
    ctx: StateContext<TableStateModel>,
    action: TableActions.SearchBondsProduct
  ) {
    this.productService
      .searchBondProducts(action.payload.searchText)
      .subscribe({
        next: (response) => {
          ctx.dispatch(
            new TableActions.LoadTableDataSuccess({
              tableKey: 'bonds',
              data: response?.data,
              totalCount: 10,
            })
          );
        },
        error: (error) => {
          ctx.dispatch(
            new TableActions.LoadTableDataFailure({
              tableKey: 'bonds',
              error: error.message,
            })
          );
        },
      });
  }

  handleCPaperProductLoad(
    ctx: StateContext<TableStateModel>,
    params: Pagination
  ) {
    this.productService.getAllCommercialPaperProducts({ ...params }).subscribe({
      next: (response) => {
        ctx.dispatch(
          new TableActions.LoadTableDataSuccess({
            tableKey: 'commercialPapers',
            data: response.data?.data,
            totalCount: response.data?.total_count,
          })
        );
      },
      error: (error) => {
        ctx.dispatch(
          new TableActions.LoadTableDataFailure({
            tableKey: 'commercialPapers',
            error: error.message,
          })
        );
      },
    });
  }

  searchCPaperProduct(
    ctx: StateContext<TableStateModel>,
    action: TableActions.SearchCPaperProduct
  ) {
    this.productService
      .searchBondProducts(action.payload.searchText)
      .subscribe({
        next: (response) => {
          ctx.dispatch(
            new TableActions.LoadTableDataSuccess({
              tableKey: 'commercialPapers',
              data: response?.data,
              totalCount: 10,
            })
          );
        },
        error: (error) => {
          ctx.dispatch(
            new TableActions.LoadTableDataFailure({
              tableKey: 'commercialPapers',
              error: error.message,
            })
          );
        },
      });
  }

  handlePMSProductLoad(ctx: StateContext<TableStateModel>, params: Pagination) {
    this.productService.getPmsProducts({ ...params }).subscribe({
      next: (response) => {
        ctx.dispatch(
          new TableActions.LoadTableDataSuccess({
            tableKey: 'pmsProducts',
            data: response.data?.data,
            totalCount: response.data?.total_count,
          })
        );
      },
      error: (error) => {
        ctx.dispatch(
          new TableActions.LoadTableDataFailure({
            tableKey: 'pmsProducts',
            error: error.message,
          })
        );
      },
    });
  }
}
